import AccountState from "@/models/Accounts/Shared/AccountState";

export default class UpdateAccountStateRequest {
    state: AccountState;
    accountStateReasonCode: string;
    accountStateReasonDescription: string = '';
}